import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import ErrorHandlerService from 'services/error-handler/service';
import { contactsAPI } from 'api/crm/contactsAPI';
import { useDispatch } from 'react-redux';
import { FormikHelpers } from 'formik';
import { setPrimaryPhoneNumber } from 'redux/actions/auth';
import { RequiredPropsForModalDialogModel } from '@ui';

// components
import { Message, Modal } from '@ui';
import {
  default as TemplateUpdatePrimaryPhoneNumberModal,
  FormValuesModel,
} from 'components/ModalDialogs/TemplateModalDialogs/Auth/UpdatePrimaryPhoneNumberModal';

type IProps = RequiredPropsForModalDialogModel;

const UpdatePrimaryPhoneNumberModal = ({
  isVisible,
  closeCallback,
}: IProps) => {
  const { t } = useTranslation(['profile', 'server_errors']);
  const dispatch = useDispatch();

  const initialFormValues = useMemo<FormValuesModel | null>(() => {
    if (!isVisible) {
      return null;
    }

    return {
      otp: '',
      phone: '',
      otpSent: false,
    };
  }, [isVisible]);

  const handleOnSubmit = async (
    values: FormValuesModel,
    helpers: FormikHelpers<FormValuesModel>,
  ) => {
    Modal.confirm({
      content: t(
        'security.update_primary_phone_number.modal_dialog.confirmation_modal.description',
      ),
      okText: t('ok', { ns: 'common' }),
      width: 500,
      cancelText: t('cancel', { ns: 'common' }),
      onOk: async () => {
        try {
          await contactsAPI.updateUserPhoneNumber(values.phone);
          dispatch(setPrimaryPhoneNumber(values.phone));
          Message.success(
            t(
              'security.update_primary_phone_number.modal_dialog.success_submit_message',
            ),
          );
          closeCallback();
          helpers.resetForm({
            values: {} as any,
            errors: {},
            touched: {},
            isSubmitting: false,
            isValidating: false,
            status: undefined,
            submitCount: 0,
          });
        } catch (error: any) {
          const errorCode = ErrorHandlerService.getErrorCodeFromError(error);
          switch (errorCode) {
            case '12010004': {
              helpers.setFieldError(
                'phone',
                t('12010004', { ns: 'server_errors' }),
              );
              break;
            }
          }
        }
      },
    });
  };

  return (
    <TemplateUpdatePrimaryPhoneNumberModal
      isVisible={isVisible}
      closeCallback={closeCallback}
      initialValues={initialFormValues}
      onSubmit={handleOnSubmit}
    />
  );
};
export default UpdatePrimaryPhoneNumberModal;
